import keyBy from 'lodash-es/keyBy';

import { CRMState } from './state';

export const customer = (state: CRMState) => (id: string | number) =>
  state.customers.find((c) => (typeof id === 'string' ? c.id.toString() : c.id) === id);

/**
 * Returns an Object containing customers
 */
export const customersObject =
  (state: CRMState) =>
  (key = 'id') =>
    keyBy(state.customers, key);

export const customersById = (state: CRMState) => keyBy(state.customers, 'id');

/**
 * Returns an Object containing customer groups
 */
export const customerGroupsObject = (state: CRMState) => keyBy(state.customerGroups, 'id');

export const activeDistributionZones = (state: CRMState) => state.zones.filter((z) => z.isActive);

/**
 * Returns contacts
 */
export const contacts = (state: CRMState) => keyBy(state.contacts, 'id');

/**
 * Returns license types
 */
export const licenseTypes = (state: CRMState) => keyBy(state.licenseTypes, 'id');

/**
 * Returns customer tags
 */
export const tags = (state: CRMState) => keyBy(state.tags, 'id');

/**
 * Returns customer service zones
 */
export const serviceZones = (state: CRMState) => keyBy(state.serviceZones, 'id');
